import { TemplateService } from "@/services/network/template";
import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";

const templateService = new TemplateService();

const useTemplateList = (params: any) => {
  const { data, isLoading, isError, refetch } = useQuery({
    queryKey: [TemplateService.QUERY_KEY.FETCH_ALL],
    queryFn: () => templateService.getTemplateList(params),
    // enabled: false,
  });

  return {
    data,
    isLoading,
    isError,
    refetch,
  };
};

const useTemplateDetail = (id: string) => {
  const { data, isLoading, isError, refetch } = useQuery({
    queryKey: [TemplateService.QUERY_KEY.FETCH_ALL, id],
    queryFn: () => templateService.getTemplateDetail(id),
    enabled: false,
  });

  return {
    data,
    isLoading,
    isError,
    refetch,
  };
};

const useTemplateCreate = () => {
  const queryClient = useQueryClient();
  const mutation = useMutation({
    mutationFn: (params: any) => templateService.createTemplate(params),
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: [TemplateService.QUERY_KEY.FETCH_ALL],
      });
    },
  });

  return {
    mutation,
    status: mutation.status,
    isPending: mutation.isPending,
  };
};

const useTemplateUpdate = () => {
  const queryClient = useQueryClient();
  const mutation = useMutation({
    mutationFn: (params: any) =>
      templateService.updateTemplate(params.id, params.data),
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: [TemplateService.QUERY_KEY.FETCH_ALL],
      });
    },
  });

  return {
    mutation,
    status: mutation.status,
    isPending: mutation.isPending,
  };
};

const useTemplateCopy = () => {
  const queryClient = useQueryClient();
  const mutation = useMutation({
    mutationFn: (id: any) => templateService.copyTemplate(id),
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: [TemplateService.QUERY_KEY.FETCH_ALL],
      });
    },
  });

  return {
    mutation,
    status: mutation.status,
    isPending: mutation.isPending,
  };
};

export {
  useTemplateCopy,
  useTemplateCreate,
  useTemplateDetail,
  useTemplateList,
  useTemplateUpdate,
};
